<template>
    <div class="home">
        <Header></Header>
        <div style="width:100%;height:auto;">
            <div style="width:98%;margin:0 auto;overflow:hidden;">
                <!-- 面包屑 -->
                <el-breadcrumb separator-class="el-icon-arrow-right" style="padding:1.2% 0;">
                    <el-breadcrumb-item :to="{ path: '/' }">当前位置：首页</el-breadcrumb-item>
                    <el-breadcrumb-item>上市公司筛选</el-breadcrumb-item>
                </el-breadcrumb>
                <!-- 搜索部分 -->
                <el-form ref="form" label-width="70px" style="width:100%;background:#fff;">
                    <h3 style="font-size:16px;line-height: 40px;margin:0 20px;border-bottom:1px solid #E0E0E0;color:#3583ED;font-weight: bold;"><img style="display: inline-block;height:14px;margin-top:2px;margin-right: 3px;" src="../../assets/upmarket/search.png" alt="">查询条件</h3>
                    <el-form-item class="labelStyle" style="margin:20px;position:relative;">
                        <span slot="label" style="font-weight: bold;">选择股票</span>
                        <el-input v-model="search.choosedItems" style="width:35%;" readonly></el-input>
                        <el-button @click="chooseUpMarket" style="margin-left: 10px;padding:12px 34px;">选择</el-button>
                        <!-- 股票弹出框 -->
                        <el-card class="box-card_one" style="position: absolute;top:44px;left:0;height:464px;width:78%;z-index: 10000;display: none;">
                            <div class="ticket_alert_box" style="width:98%;height:368px;margin:0 auto;overflow:hidden;">
                                <div class="ticket_alert_l_one" style="width:30%;height:100%;margin-right:4%;display: inline-block;overflow:hidden;float:left;">
                                    <el-form-item label="股票搜索" style="margin-top:16px;font-weight: bold;">
                                        <el-input id="searchOne" @input="querySearch()" @click.native="querySearch()" v-model="search.state" style="width:100%;" size="small" suffix-icon="el-icon-search"></el-input>
                                    </el-form-item>
                                    <div class="ticket_alert_l_one_ztree" style="width:99%;height:297px;border:1px solid #dfdfdf;margin-top:10px;border-radius: 4px;overflow:scroll;">
                                        <!-- 树形图 -->
                                        <div style="margin:10px;width:120%;height:100%;position: relative;">
                                            <el-tree 
                                                ref="tree" 
                                                :data="search.treeeData" 
                                                :indent="16" 
                                                show-checkbox 
                                                node-key="lable" 
                                                :props="search.defaultProps" 
                                                @check="handleNodeClick" 
                                                style="width:100%;height:100%;">
                                            </el-tree>
                                            <!-- <elTree2
                                                ref="tree" 
                                                :data="search.treeeData" 
                                                :indent="16" 
                                                show-checkbox 
                                                :props="search.defaultProps" 
                                                @check="handleNodeClick" 
                                                style="width:100%;height:100%;">
                                            </elTree2> -->
                                            <!-- <span style="width:16px;height:10000px;background:#fff;position: absolute;top:0;left:23px;z-index: 10000;"></span> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="ticket_alert_l_two" style="width:30%;height:100%;margin-right:4%;display: inline-block;overflow:hidden;float:left;">
                                    <el-form-item style="overflow: hidden;margin-top:22px;">
                                        <span style="font-weight:bold;color:rgb(96, 98, 102);">可选股票[{{search.canSelect.length}}]个</span>
                                        <el-checkbox :indeterminate="search.isIndeterminate" v-model="search.checkAll" @change="handleCheckAllChange" style="float:right;">全选</el-checkbox>
                                    </el-form-item>
                                    <div style="margin-top: 6px;width:99%;height:296px;border:1px solid #dfdfdf;border-radius: 4px;overflow:scroll;">
                                        <el-checkbox-group v-model="search.checkedCities" @change="handleCheckedCitiesChange">
                                            <el-checkbox v-for="item in search.canSelect" :label="item.stockName" :key="item.enterpriseCode" style="width:90%;margin:0 auto;display: block;">{{item.stockName}}</el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                </div>
                                <div class="ticket_alert_l_three" style="width:30%;height:100%;display: inline-block;overflow:hidden;float:left;">
                                    <el-form-item style="overflow: hidden;margin-top:22px;">
                                        <span style="font-weight:bold;color:rgb(96, 98, 102);">已选股票[{{search.checkedCities.length}}]个</span>
                                        <span @click="removeClickedUpMarketFn" style="float: right;color:#ef3938;cursor: pointer;">全部删除</span>
                                    </el-form-item>
                                    <div style="margin-top: 6px;width:99%;height:296px;border:1px solid #dfdfdf;border-radius: 4px;overflow:scroll;">
                                        <ul style="padding:2px 10px;">
                                            <li v-for="(item,key) in search.checkedCities" :key="key" @click="removeOneSelectedUpMarketFn(item)" style="width:100%;white-space: nowrap;cursor: pointer;">
                                                <img src="../../assets/upmarket/remove.png" alt="" style="display: inline-block;height: 13px;margin-right: 4px;">
                                                <span style="font-size: 14px;display: inline-block;line-height: 1;width:90%;">{{item}}</span>
                                            </li>
                                            
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="search_upmarket_btn" @click="searchUpmarketBtn" style="background:#3584ed;color:#fff;width:80px;height:30px;text-align: center;line-height: 30px;border-radius: 2px;float:right;margin-right: 2.2%;margin-top:20px;cursor: pointer;">确定</div>
                        </el-card>
                        <!-- <el-button>股票导入</el-button> -->
                        <el-upload class="upload-demo" style="display: inline-block;"
                            ref="upload"
                            :action="search.uploadUrl"
                            :show-file-list="false"
                            :on-success="successUpload"
                            :file-list="search.fileList"
                            :auto-upload="true"
                            accept=".txt"
                            :limit="1">
                            <el-button>股票导入</el-button>
                        </el-upload>
                        <el-button @click="downloadFiles" style="border:none;color:#3583ED;margin-left:0;padding:12px 10px;">文件模板</el-button>
                    </el-form-item>
                    <el-form-item style="margin:20px;">
                        <span slot="label" style="font-weight: bold;">选择数据</span>
                        <el-select @change="searchTextSelectFn" v-model="searchData.value" placeholder="请选择" style="width:35%;">
                            <el-option
                              v-for="item in searchData.select"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                        </el-select>
                        <span v-show="searchData.value != 0" style="margin-left:10px;">选择报告期</span>
                        <el-select @change="changeDateFn" v-show="searchData.value != 0" v-model="searchData.quarterValue" multiple collapse-tags :multiple-limit="5" placeholder="选择报告期" style="width:35%;margin-left: 10px;">
                            <el-option
                              v-for="item in searchData.quarter"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="margin:20px;position:relative;">
                        <span slot="label" style="font-weight: bold;">选择字段</span>
                        <el-input v-model="searchText.choosedItems" style="width:35%;" readonly></el-input>
                        <el-button @click="chooseTextFn" style="margin-left:10px;padding:12px 34px;">选择</el-button>
                        <!-- 选择字段弹出框 -->
                        <el-card class="box-card_two" style="position: absolute;top:44px;left:0;height:430px;width:48%;z-index: 10000;display: none;">
                            <div class="ticket_alert_box" style="width:98%;height:350px;margin:0 auto;overflow:hidden;">
                                <div class="ticket_alert_l_two" style="width:47%;height:100%;margin-right:4%;display: inline-block;overflow:hidden;float:left;">
                                    <el-form-item style="overflow: hidden;">
                                        <span style="font-weight:bold;">可选字段[{{searchText.canSelect.length}}]个</span>
                                        <el-checkbox :indeterminate="searchText.isIndeterminate" v-model="searchText.checkAll" @change="handleCheckAllChange2" style="float:right;">全选</el-checkbox>
                                    </el-form-item>
                                    <div style="margin-top: 6px;width:99%;height:296px;border:1px solid #dfdfdf;border-radius: 4px;overflow:scroll;">
                                        <el-checkbox-group v-model="searchText.checkedCities" @change="handleCheckedCitiesChange2">
                                            <el-checkbox v-for="item in searchText.canSelect" :label="item.indicatorName" :key="item.indicatorId" style="width:90%;margin:0 auto;display: block;white-space: nowrap;">{{item.indicatorName}}</el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                </div>
                                <div class="ticket_alert_l_three" style="width:47%;height:100%;display: inline-block;overflow:hidden;float:left;">
                                    <el-form-item style="overflow: hidden;">
                                        <span style="font-weight:bold;">已选字段[{{searchText.checkedCities.length}}]个</span>
                                        <span @click="removeClickedUpMarketFn2" style="float: right;color:#ef3938;cursor: pointer;">全部删除</span>
                                    </el-form-item>
                                    <div style="margin-top: 6px;width:99%;height:296px;border:1px solid #dfdfdf;border-radius: 4px;overflow:scroll;">
                                        <ul style="padding:2px 10px;">
                                            <li v-for="(item,key) in searchText.checkedCities" :key="key" @click="removeOneSelectedUpMarketFn2(item)" style="width:100%;white-space: nowrap;cursor: pointer;">
                                                <img src="../../assets/upmarket/remove.png" alt="" style="display: inline-block;height: 13px;margin-right: 4px;">
                                                <span style="font-size: 14px;display: inline-block;line-height: 1;width:90%;">{{item}}</span>
                                            </li>
                                            
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="search_upmarket_btn" @click="searchTextBtn" style="background:#3584ed;color:#fff;width:80px;height:30px;text-align: center;line-height: 30px;border-radius: 2px;float:right;margin-right: 2.2%;margin-top:12px;">确定</div>
                        </el-card>
                    </el-form-item>
                    <el-form-item style="padding-bottom:20px;margin-bottom: 0;">
                        <el-button @click="searchAllBtnLogin(1)" type="primary" style="margin-left:20px;padding:12px 40px;">查询</el-button>
                    </el-form-item>
                </el-form>
                <!-- 搜索下面展示部分 -->
                <div class="upmarket_main_box" style="width:100%;overflow:hidden;">
                    <div class="main_tabBox" style="overflow:hidden;height:52px;line-height: 52px;border-bottom:1px solid #f4f4f4;">
                        <span class="graphTab1" @click="graphTabFn(1)" type="1" style="display: inline-block;height:42px;line-height: 42px;padding:0 20px;margin-top:10px;background:#fff;cursor: pointer;font-weight:bold;color:#3583ED;">可视化</span>
                        <span class="graphTab2" @click="graphTabFn(2)" type="2" style="display: inline-block;height:42px;line-height: 42px;padding:0 20px;margin-top:10px;cursor: pointer;font-weight:bold;">公司列表</span>
                    </div>
                    <div v-show="graph.tabBool" style="background:#fff;padding-top:20px;">
                        <ul style="width:98%;margin:0 auto;">
                            <li style="width:32%;display: inline-block;margin-right:1.5%;">
                                <h4 style="font-family:Microsoft YaHei;font-size: 16px;color:#121212;font-weight:bold;height:36px;line-height:36px;border-bottom:1px solid #E0E0E0;margin-bottom:10px;"><img style="display: inline-block;height:16px;margin-right:4px;" src="../../assets/upmarket/title_logo.png" alt="">上市公司总数</h4>
                                <div id="upmarket_allcount" style="width:100%;height:330px;"></div>
                            </li>
                            <li style="width:32%;display: inline-block;margin-right:1.5%;">
                                <h4 style="font-family:Microsoft YaHei;font-size: 16px;color:#121212;font-weight:bold;height:36px;line-height:36px;border-bottom:1px solid #E0E0E0;margin-bottom:10px;"><img style="display: inline-block;height:16px;margin-right:4px;" src="../../assets/upmarket/title_logo.png" alt="">上海证券交易所</h4>
                                <div style="width:100%;height:330px;">
                                    <div style="height:100%;width:390px;margin:0 auto;position: relative;">
                                        <span style="display:block;position: absolute;top:90px;left:7%;width:110px;height:110px;background:#1071C9;border-radius:50% 50%;">
                                            <i style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 7;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{graph.count1[0] ? graph.count1[0].num : ''}}</i>
                                            <i style="display: block;width:86%;height:1px;background:#fff;margin:0 auto;"></i>
                                            <i style="display: block;width:86%;height: auto;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{graph.count1[0] ? graph.count1[0].NAME : ''}}</i>
                                        </span>
                                        <span style="display:block;position: absolute;top:43px;left:44%;width:100px;height:100px;background:#F4724A;border-radius:50% 50%;">
                                            <i style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 6.8;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{graph.count1[1] ? graph.count1[1].num : ''}}</i>
                                            <i style="display: block;width:86%;height:1px;background:#fff;margin:0 auto;"></i>
                                            <i style="display: block;width:86%;height: auto;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{graph.count1[1] ? graph.count1[1].NAME : ''}}</i>
                                        </span>
                                        <span style="display:block;position: absolute;top:90px;left:70%;width:80px;height:80px;background:#868686;border-radius:50% 50%;">
                                            <i style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 5;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{graph.count1[2] ? graph.count1[2].num : ''}}</i>
                                            <i style="display: block;width:86%;height:1px;background:#fff;margin:0 auto;"></i>
                                            <i style="display: block;width:86%;height: auto;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{graph.count1[2] ? graph.count1[2].NAME : ''}}</i>
                                        </span>
                                        <span style="display:block;position: absolute;top:150px;left:51%;width:80px;height:80px;background:#128239;border-radius:50% 50%;">
                                            <i style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 5;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{graph.count1[3] ? graph.count1[3].num : ''}}</i>
                                            <i style="display: block;width:86%;height:1px;background:#fff;margin:0 auto;"></i>
                                            <i style="display: block;width:86%;height: auto;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{graph.count1[3] ? graph.count1[3].NAME : ''}}</i>
                                        </span>
                                    </div>
                                </div>
                            </li>
                            <li style="width:32%;display: inline-block;">
                                <h4 style="font-family:Microsoft YaHei;font-size: 16px;color:#121212;font-weight:bold;height:36px;line-height:36px;border-bottom:1px solid #E0E0E0;margin-bottom:10px;"><img style="display: inline-block;height:16px;margin-right:4px;" src="../../assets/upmarket/title_logo.png" alt="">深圳证券交易所</h4>
                                <div style="width:100%;height:330px;">
                                    <div style="height:100%;width:390px;margin:0 auto;position: relative;">
                                        <span style="display:block;position: absolute;top:90px;left:7%;width:110px;height:110px;background:#1071C9;border-radius:50% 50%;">
                                            <i style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 7;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{graph.count2[0] ? graph.count2[0].num : ''}}</i>
                                            <i style="display: block;width:86%;height:1px;background:#fff;margin:0 auto;"></i>
                                            <i style="display: block;width:86%;height: auto;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{graph.count2[0] ? graph.count2[0].NAME : ''}}</i>
                                        </span>
                                        <span style="display:block;position: absolute;top:43px;left:46%;width:90px;height:90px;background:#F4724A;border-radius:50% 50%;">
                                            <i style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 5.8;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{graph.count2[1] ? graph.count2[1].num : ''}}</i>
                                            <i style="display: block;width:86%;height:1px;background:#fff;margin:0 auto;"></i>
                                            <i style="display: block;width:86%;height: auto;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{graph.count2[1] ? graph.count2[1].NAME : ''}}</i>
                                        </span>
                                        <span style="display:block;position: absolute;top:90px;left:68%;width:100px;height:100px;background:#868686;border-radius:50% 50%;">
                                            <i style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 6.5;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{graph.count2[2] ? graph.count2[2].num : ''}}</i>
                                            <i style="display: block;width:86%;height:1px;background:#fff;margin:0 auto;"></i>
                                            <i style="display: block;width:86%;height: auto;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{graph.count2[2] ? graph.count2[2].NAME : ''}}</i>
                                        </span>
                                        <span style="display:block;position: absolute;top:140px;left:42%;width:98px;height:98px;background:#128239;border-radius:50% 50%;">
                                            <i style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 6;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{graph.count2[3] ? graph.count2[3].num : ''}}</i>
                                            <i style="display: block;width:86%;height:1px;background:#fff;margin:0 auto;"></i>
                                            <i style="display: block;width:86%;height: auto;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{graph.count2[3] ? graph.count2[3].NAME : ''}}</i>
                                        </span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <ul style="width:98%;margin:0 auto;">
                            <li style="width:67.8%;display: inline-block;margin-right:1.5%;">
                                <h4 style="font-family:Microsoft YaHei;font-size: 16px;color:#121212;font-weight:bold;height:36px;line-height:36px;border-bottom:1px solid #E0E0E0;margin-bottom:10px;"><img style="display: inline-block;height:16px;margin-right:4px;" src="../../assets/upmarket/title_logo.png" alt="">上市公司区域分布图</h4>
                                <div id="upmarket_echarts_map" style="width:100%;height:700px;"></div>
                            </li>
                            <li style="width:30%;display: inline-block;">
                                <h4 style="font-family:Microsoft YaHei;font-size: 16px;color:#121212;font-weight:bold;height:36px;line-height:36px;border-bottom:1px solid #E0E0E0;margin-bottom:10px;"><img style="display: inline-block;height:16px;margin-right:4px;" src="../../assets/upmarket/title_logo.png" alt="">各地区上市公司数量</h4>
                                <div id="upmarket_echarts_num" style="width:100%;height:700px;"></div>
                            </li>
                        </ul>
                        <ul style="width:98%;margin:0 auto 70px;overflow:hidden;">
                            <li style="width:57.8%;display: inline-block;margin-right:1.5%;overflow:hidden;">
                                <h4 style="font-family:Microsoft YaHei;font-size: 16px;color:#121212;font-weight:bold;height:36px;line-height:36px;border-bottom:1px solid #E0E0E0;margin-bottom:10px;"><img style="display: inline-block;height:16px;margin-right:4px;" src="../../assets/upmarket/title_logo.png" alt="">上市公司新增数量随时间分布情况</h4>
                                <div id="upmarket_echarts_timeNum" style="width:100%;height:350px;"></div>
                            </li>
                            <li style="width:40%;display: inline-block;overflow:hidden;">
                                <h4 style="font-family:Microsoft YaHei;font-size: 16px;color:#121212;font-weight:bold;height:36px;line-height:36px;border-bottom:1px solid #E0E0E0;margin-bottom:10px;"><img style="display: inline-block;height:16px;margin-right:4px;" src="../../assets/upmarket/title_logo.png" alt="">上市公司行业分布情况</h4>
                                <div id="upmarket_echarts_work" style="width:100%;height:350px;overflow:hidden;color: #fff;text-align: center;"></div>
                            </li>
                        </ul>
                    </div>
                    <div class="showTablesDiv" v-show="!graph.tabBool" style="background:#fff;padding-top:20px;width:100%;">
                        <div @click="downloadFn(0)" style="float:right;height: 18px;font-size:14px;cursor: pointer;overflow: hidden;margin-top:0;margin-left:20px;margin-bottom:20px;margin-right:25px;">
                            <img src="@/assets/img/Excel.png" alt style="display: inline-block;height: 18px;width:18px;float:left;" />
                            <span style="display: inline-block;height: 18px;line-height: 18px;width:auto;vertical-align: middle;color:#3583ED;margin-left:4px;float:left;">下载数据到Excel</span>
                        </div>
                        <!-- :show-header="false" -->
                        <el-table
                            v-loading="graph.loading"
                            :fit="true"
                            size="mini"
                            style="width:97%;margin:20px auto;"
                            :data="graph.tableData"
                            :header-cell-style="{'color': '#333333','font-weight':'bold','font-family':'Microsoft YaHei','background':'#F7F7F7'}"
                            @row-click="cellClickFn"
                            @sort-change="sortChangeFn"
                            :cell-style="cellStyle"
                            border>
                            <!-- tableOrderData -->
                            <el-table-column
                                v-for="(item,index) in graph.tableData[0]"
                                :prop="index"
                                :label="item"
                                :show-overflow-tooltip="true"
                                :sortable="isInArray(graph.tableOrderData,item) ? 'custom' : false"
                                align="center"
                                :key="index"
                                :fixed="(index == 0 || index == 1) ? true : false "
                                :width="graph.tableColumnWidth[index] < 24 ? graph.tableColumnWidth[index] * 16 : (graph.tableColumnWidth[index] * 8)"
                                >
                                <!-- :width="(graph.tableData[1][index] == null || graph.tableData[1][index] == '' || Number(graph.tableData[1][index])) ? graph.tableData[0][index].length * 27 : (graph.tableData[1][index].length <4 ? graph.tableData[1][index].length * 85 : (graph.tableData[1][index].length > 100 ? graph.tableData[1][index].length * 16 :graph.tableData[1][index].length * 29))" -->
                            </el-table-column>
                        </el-table>
                        <div style="width:100%;padding-bottom:20px;margin-left:20px;">
                            <el-pagination
                                prev-text="上一页"
                                next-text="下一页"
                                background
                                :current-page="graph.currentPage"
                                @current-change="handleCurrentChange"
                                :page-size="graph.limit"
                                layout="total, prev, pager, next, jumper"
                                :total="graph.total"
                            ></el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
import Header from '@/components/header2'
import Footer from '@/components/footer'
import $ from 'jquery';
import api from '@/../static/common/api/api.js';
window.api = api;
import echarts from 'echarts';
// import '@/../plugins/echarts/china.js';
import  test from '@/../static/plugins/chinese-map/static/map/china.json';
// echarts.registerMap('china', { "type": "FeatureCollection", "features": [{ "type": "Feature", "id": "xin_jiang", "properties": { "name": "新疆", "cp": [84.9023, 41.748], "childNum": 18 }, "geometry": { "type": "Polygon", "coordinates": ["@@@ρȁôƧƦóəʵסʵóƪԫʵѵͩƧͩړυࡓɛʵ@ȃ@óᇑѵƨɝɚôóНѺͩɜ̏ԭʵôƧɞñ@υƩ݇ȂóƩƧ@ѵȂυƥŌਗ॥ɛóʵѵƧѹ݇̍ࢯəɞυρͩ̏óਙƨƧŋôōó̍ͩóʵןóŋړͪƧѶ@ɜԭԫƦɛȄ̍ɝȄöςƩȂ̏ñȀ̏ƩóóŎə@Ő̎@ɞȀɝŎôƨóנѵȄƧ@óŏɝóɜôŎ̍ͨςŎ@ƨóôƨɞ݈ʶóƨφó̎Ȁƨ̍ԮòѸԮמ@ѺȀ@ƪၬֆòȂñ̐òȂɜóƨ̒Ŏ̑߼@φρȀ@Ő๐ς̎Ƨφ@ɝφڔ೦Ԯǿࢰ@ƦŏԮƨƨȄƧ۬ɜʶڔŐɚɚóŐôƨ߼ôƧƧó̐ƥóŏѺǿƦȁφƧςƨƧ̒@ɜƥƦυ̐ɛƪͩƩəƪʷ̑ə@ȃƨʵנŋྸōਚԭԪ@ɝƨŋ̒օςʵôƧ"], "encodeOffsets": [[98730, 43786]] } }, { "type": "Feature", "id": "xi_zang", "properties": { "name": "西藏", "cp": [88.7695, 31.6846], "childNum": 7 }, "geometry": { "type": "Polygon", "coordinates": ["@@ôŌנôʶ̎ͪôóŎƨŌਚƧ̐ôςͪφɚɝࢰ݈̎ѺѶƨôʶ०ɜਘƦŋφѶȁ̍ôŏɚŋ@̑ə@ŏò̍ɜóƥôʷƧ̍φѹԪ̍ע@Ѹʷɜ@ôñנ@Ѷɛɞô̐ŏѶƨѸƧƥōƦôŏô@ƧôƩ̒ŋƨŌƦǿô̎ɜȁ̒óʶѶôôО̒ςƥɜНφσɛȁ̎υƨఱƧŏ@ʵƥ@ŌóóóͩƨƧóŋ̑õóɞóɝԩͪɝρôƧ̍ƧѹͨڑŎ̑ōóƧࢭͩ̏ѵɝóఱóóԪυô@̒ƥŌ̏Ƨ̑Ȅ݇ŎƧѵӏ@ɛõŏɛȄôӒƧŌѵǿɝƧŋԫ@̏ʴƥ@óǿ̑Ȁóǿ̍ςóóυô@ʶɛñρƦƩŐó̎óѵó̑ͪࢯОóɜןƧ̏ƥȄ߻̎̏̐ןŎɝɜöɞƩȀôöɛȀóͪ̐ƨƪ̍̎ȂƥԪυО@φɞôƪ"], "encodeOffsets": [[80911, 35146]] } }, { "type": "Feature", "id": "nei_meng_gu", "properties": { "name": "内蒙古", "cp": [117.5977, 44.3408], "childNum": 12 }, "geometry": { "type": "Polygon", "coordinates": ["@@ኊȁ૊ö߼ƩɜɛנñԮɛѶóԮô@ȁѸóמ̎ගѺၬ@߼ʶԮӒ߼̎@ŐѹӒ̒Ԫƨöග̑ѶȄ̒ς।ѶɚöɞɜʴڔôôȂ̎ѺȀςƨƪóԪɜôɛОਕڔԭѵ̍ѹȂԫɛƥ̍Ȃóɜ̎ô@ʶ݊ੲࢮʵږͪנƨôȂƧ̐ͪ@ŐƦƨφԬѶɜôƦ@ŐƧôôƦəŐ̏@ŐڒѶԬô̐ʳԩНςōôŏɞ@ƨȂѶəóƧ̒ػ̎ó̐Őנóƨô̒@ƨɚɚ@עԫɛɛ@ȁυͩƥʳòևρ̑ࡗƧͪ༃ॣԮփ̎Ʀ@ôô@ôō@@ȁѵóƨ̍υȃóʵɛƨƥóυȂóəƪ̐ρƧͩɜԭڔȄ̎عƧȁ̐ŏó̍ɛƥƧ̑óρŐ@Ƨ̏ɝəɛ߻ͩ̍ͩɝО̍ƪƧóóӓƨóƧʳ݇@ɝςƪ@ʴƩƧƦôƨɛȄəƧŋυóͩѵ@ɝǿóŌן̍ɛóО̍̑̏ôȁ̍ŏòȁñóƦͩ@ǿə@ɛƧ̑ρȁυô̍օѹóȃə@ȂσʵѷƪòƩ̍ôó߻ۯôʳƧóõʵѵóѹɜ̍ȂѹôɛŌφֈƩͨρóυӑóޟఱ̑݇ͪóƪƨŌóȄڔԬƩςםñ̑ȃѵŐԭŏƨȁɛǿρôõɚɛóƧОə@ѹ̐ѵöԪͨôͪɛ̒ןŏƧƥóôƥƧɛŌôóɝó@̒݇Ӓ̒Ō@Ŏԭࢰ"], "encodeOffsets": [[99540, 43830]] } }, { "type": "Feature", "id": "qing_hai", "properties": { "name": "青海", "cp": [96.2402, 35.4199], "childNum": 8 }, "geometry": { "type": "Polygon", "coordinates": ["@@ƨ@ôƪ݈ȁƪ@φɝòóƨԮʶɛ̐ѹͪôОəóƧɞᇒѶ@ôږô@ǿѶƪȁςɜͩφςŋɞôѶɛƨŌɞ@ɚςŐñԪॢͩƨȂɞóƨŐ̎ŏעӏ̎óƧƦô̒ȁɜςͩ̒ɚɛƨôƨɝφɛóȁƨŋóóɚͩƨóóƩ@ƧəŋƦƩ̍@ƧƧôǿυ̑@ȁɞǿõŏρƥסɚƧóτԫɞôƧƦ@ñȃòñƥóυôôѹѵ@ŏ̏Ȅɝó@ȂəŌóəѹƦ@Ő̍Ōυ݈ԩŐƧóôƧ̑ôʵɞƧ̑ѵôƩɞƧ̑óНѵóôʵ̑ɛȂó̍ƥȀƧŋ̑Ōóƪ@ƨóóŐƥƦŎѷƨѵƧ̏Őɝóѵɜן@óòɛ@ѷʸס@ԩ̎υѺƨ̎óʸôƦɛñ̎@Őɚ@̒əŌóŐ̎"], "encodeOffsets": [[91890, 36945]] } }, { "type": "Feature", "id": "si_chuan", "properties": { "name": "四川", "cp": [102.9199, 30.1904], "childNum": 21 }, "geometry": { "type": "Polygon", "coordinates": ["@@ôôŋó̑Ԯ̒ɛОמͪƨōöͫ߼ƥôȃƨóóñôƧóƧôōڔŏƨŐ@ŎôòƥѺŎ@ōɜóנôǿôƦôԮ̍ɜôɚƧñɛɚȁ̍Ƨɛևυ@óóôŋρԭɝ@Ƨʸ̍ŏυɜƧƧóƧƨȁρ̍ƨȃɚôʵφóô̑̏Ȃ̑ʵɜʵɞ@ƨʳסƩóŎəóɜƧôƩƧρóôôô@ŎƧƨƨƪѹó̍̍Ʃ@̏ѹНôޟ̍ƩóƪυɝɛəƨôŎɛȀ@Ȃ@ñɝʶ@Ōρנ̏õóɛͨƨȂѵОɛʵ@̏ƩŐó߼Ƨల̍φɜȂυτɛОρƦɝƨóƪ̒Ѷɝƨóʶ̒óƨƨôԪŏφ݇̎ŋ@ŏѺƥôɚɚŋ@ȁɞô̐ȃ@ŐѶóѺφóƦôñòòȄ"], "encodeOffsets": [[104220, 34336]] } }, { "type": "Feature", "id": "hei_long_jiang", "properties": { "name": "黑龙江", "cp": [128.1445, 48.5156], "childNum": 13 }, "geometry": { "type": "Polygon", "coordinates": ["@@ᇔȂਚНƨŐѶŏöƥςŏñƧƦóƨȁ@óƨóȁφӑóóƨóǿ̎̑ôНɞó̑ɜə߼̎ǿ̒ôڒӑφ@Ƨȁ̎̏ƥƩ̎ρశôȂςƨφ@נɞ݈̑ƥƧɛƨʵƧȃƥ@Ƨƥ@ŏ̑ԩôɝρρóɛƧƩͩƧó߻ʸ̍ʷѹƥɞڕõ̍öɝυ̍ȂƧ̐̑ŏóƨñŋѹóóȁ̍̏Ԭõʸ̏ŏ@ǿ̍@ƧОυ@ñƨòȀƥŎ̑ŐѵóɛŌóȂԫōƧŎѹñ̍ʶóОן@Ƨ̎Ѷô@Ȃ@óŎó@@ó̍ƥԭք༄।ƨͩ̒ࡘςñֈƦʴφͪ@ȂɜɜסԬə@Ƨə̑@Ƨóןô̏ŏ̍ô̑ؼôƨѵɚƧȁɝ@óŐρŎԪО̏ʴ"], "encodeOffsets": [[124380, 54630]] } }, { "type": "Feature", "id": "gan_su", "properties": { "name": "甘肃", "cp": [95.7129, 40.166], "childNum": 14 }, "geometry": { "type": "Polygon", "coordinates": ["@@ڔôԮࢯ@ō̑ŋ݈ӑ@̑ɞôóôɜŋƦƨôóƨƦנŐɜ̑óͩԩͧѶõѺ̏ɚ@ƨНɜôöəςóɜȀƧȂԮŐѶŏ̒ȄמòƪρړԫôȃƧŋôƩ݈ͩɚ@@ǿɜ@φͩóŏɜӑƧōôǿ̎ôƥƪóõö@ôƨôƧƦôó̒ɜ@ɞŌõʶ̏Ő@ȀóôƨȂ@ʶע@@ƥ୾ӑó̑óŋôʵóɛړ@@ƩöóƩóρɛƨ̑@óʷƥƥ̎ɛƧôōƧǿôͩѵôɝȃɞȁõƧρóó@ōƧŏړŐóŎôƨóƨôòƧôóȄ߻ƦõͬƧŎםͩɜНԭ̑ô̒óŌóƥ@óƨɝσԬƨôעəςƦöŐɝȀ@Ȃφ̒óȀƨƨ̎@ƥƪɚŌ@ƨôƪƧôəͪôôƧŌôȂυɜƧɞƧóəɜ̑ρͪɛ̑Ȃóƨƥ̍ôסӐ̍ŐƧŏɝôƧȁॡͪòԩρŏ@əɝƧŋѵɜɝóρŌυɛͪρƩȂѵ@Ȁڕó@ȄɜʶφࡔڔƨͪѶͪԬʶôƩעʶɚʶƥôóƨςȂ"], "encodeOffsets": [[98730, 43740]] } }, { "type": "Feature", "id": "yun_nan", "properties": { "name": "云南", "cp": [101.8652, 25.1807], "childNum": 16 }, "geometry": { "type": "Polygon", "coordinates": ["@@ôɞôɝ̒öôŌƧƨôͪôô@ŋƦ@ʶƨŐô߻ƪŏ@̐ɜʶѶНƧȁɜͧöô̐ςן@ŋɞʵ@ò@ȁɜǿóōɚƧɜφɞôƩ̎ƪóޠѺО@̐̎ƪô̎ѺƧƩƨƧ@ōóóôóςƪƨƨóôɛó̑ԭƥŌɛǿɝƨɛͩô@ǿƨȁѺŌɚɛ̍ןѶНɛƧôóƥȁƦͩôŎɞƨ̑ɜòôφ@ƨʵ@ɛѹōóȃəƨυǿóʵρƧƧŌƩɛ̏ȄñƧƧȀɝ̍ԩʶƧ̑υóŌƥʳɚӑóНƥô̑óӒѵʵѹƧӐןôƪφõŌƪ̒ԫŌƧؼƨƨסρȁƧƨȂóʶó@@ʴƨôôφ̎Ŏ@ȀƨƪɚƨóƨôôôςóޤƧŌƩŋƧԪ"], "encodeOffsets": [[100530, 28800]] } }, { "type": "Feature", "id": "guang_xi", "properties": { "name": "广西", "cp": [108.2813, 23.6426], "childNum": 14 }, "geometry": { "type": "Polygon", "coordinates": ["@@ƦŋѺ̎ڔʵƨŐ@ƦמȄƪôóȂɜŌɚͩɜ@öóɜôôȂƦôɜȁ@ɞφóȄ̎ƨʶɞŋƨʴɚǿ̐̎Ԭ@ôñ@̏ƨρ۫ôɚƨƨНƪŐ̎ƥóƦʵƥŋ@ȃóƥƧ@@ŏɝǿôυƧȁѵɛ@əóŏ̑@@ə̍óƧó@ȁƩρóòНƥô@Ӓ̑@óŎ̍ƥσŎυ@̍ƨ@Ō̑ôóͪƨ̒óŌړ̏Ŏ@ŌôȄѺŎ@ɜƧʶυ@ñóɛƧ̒ɝóōƥͪ"], "encodeOffsets": [[107011, 25335]] } }, { "type": "Feature", "id": "hu_nan", "properties": { "name": "湖南", "cp": [111.5332, 27.3779], "childNum": 14 }, "geometry": { "type": "Polygon", "coordinates": ["@@@քɜОƨ@öŐמóƪôƩɚ̒Ő߼ȁςͩɜòƪɜȀòñɝòѺͪ@ŏƨŋóɝôǿƨɚȃóəƨȃѵͩó̍@ȃƨóóƥƨƧ@ʵƦóͩɜɛóñԭɛōυȂ̍ƧƦō@ɛƥɛȀ̑óʷóō̍ƩŏƧОəƧóς۬Ƨ@̐óòԫ@̏̍əȀƧʳɝŌóɞƧƨɜóŐƨò@ȄƧŌρŋóôԪОóʶ@̎óȄ"], "encodeOffsets": [[111870, 29161]] } }, { "type": "Feature", "id": "shan_xi_1", "properties": { "name": "陕西", "cp": [109.5996, 35.6396], "childNum": 10 }, "geometry": { "type": "Polygon", "coordinates": ["@@ςôöƨɝȂɞȄѶóóͪƨȀóŎƨ̍ɜƦƦôʸ̒@ɜƧςƪôõô@ƪڔ@ôɜóʶôŌô̒୽Ӓ@Ʀ@Ѻ̎ɜѺɛѶôöʶôƨóʴ߼۰óô̎ñƪѸƩτʶ@ȁòŋəѹóǿ̑ʵ@ȁ̒ʷυփô݉ôН̏ط@ȁƨóô̏ƪõ@ʳ̐ʵ@ɝɛŋƩŌɛóןôƧŋ̒ó@ŏ̐ƥ@ŏυ@ƧƧôן̏@ƥȂѹɜəɛóԭ̎ƥóóóȀןɛô@ŎѹōñƦ"], "encodeOffsets": [[108001, 33705]] } }, { "type": "Feature", "id": "guang_dong", "properties": { "name": "广东", "cp": [113.4668, 22.8076], "childNum": 21 }, "geometry": { "type": "Polygon", "coordinates": ["@@@Ȃôôƨ̎@ɚ̒@ôŐ@ɚѶɜƨȂóφɞȀ@Őƨ@ôƦ@ȄƦŌƥʶƦôôŎôʸ̒ɜǿƦ@ɜƥŎ̎ƨφȁɜŎòƥԮŎƨōóŏɛƧɝəɞƧ߼ɜςȃñȄƦŎ̒ōôòƨəƨɚН@əƨ̏ƪʵυŌəɛóəԭŏəóŏѹρʵɝƦ̏ƥʳѶöō̑óóŋρȀυƧƥɛѹōƧôןɛŏѵ@óŋôʵɝƪԩõ@Ƨō̍@Ƨ@@ƦɝԮƪО@@", "@@X¯aWĀ@l"], "encodeOffsets": [[112411, 21916], [116325, 22697]] } }, { "type": "Feature", "id": "ji_lin", "properties": { "name": "吉林", "cp": [126.4746, 43.5938], "childNum": 9 }, "geometry": { "type": "Polygon", "coordinates": ["@@נ@ôН̎ʵѺòƨōԬŎôȁɜŋѶô̒ŏƦōñǿòƧφ@ƨН̎@@Ȁ̐Őöʷ̐ԫ̎ôȂѺôòŌôƧ̒Őƨ̏̎ȁφ@ŋƩͩםȃƨ@ȁ̑ʶ@Ōóôɛƥѹ̑συ݇@ɜρƧȃࢯƨôəȂɛōƩɛ̏υρóõƪʴυφ@ʶôŌóρք@ɜƧ@ɝǿƧͪρȀƩó̏ŐƨȂ̍غړȃɛԮƨͪ̏ςƩôɚφȁƦôɜƧôʶφȄ"], "encodeOffsets": [[126181, 47341]] } }, { "type": "Feature", "id": "he_bei", "properties": { "name": "河北", "cp": [115.4004, 37.9688], "childNum": 11 }, "geometry": { "type": "MultiPolygon", "coordinates": [["@@Ʃ̒̏ŌѺ̒ƩóȄƧŌƥͪòôñȂ̎ŐóȂ̒̐̎ôНɜנ̎ôŋɞȀѶ@ôͪφƨŌɚɜȃóƧƨƥƪ@ʳƩɞρ݈@υНφʵɜƦρƨƧ̍ɝóɛѹ̍ρŏ̑ôóƨ@ƧƦôƨɛ@ƥƨ@ȂƦ@@ôəŐƧʶƨŌυ̍̎ɛŋôōɝ@óƧ̍ƦʵѵʳôʵɜŏςôƪŋƨŌɚ@ôНƥƧ@ōѸɛ̐ô̎ʵѵНԭ@̍̍Ƨò@ȁɝ@əρυͩƪ̏ƩõƧŎƧōóॡȄɛʶɜȀ@ɞςѶƧƥςɛŐ@ɚɜɜ@Ŏôôςƪς"], ["@@õə@Ƨɛ@ŐóƦφô"]], "encodeOffsets": [[[117271, 40455]], [[120061, 41040]]] } }, { "type": "Feature", "id": "hu_bei", "properties": { "name": "湖北", "cp": [112.2363, 31.1572], "childNum": 17 }, "geometry": { "type": "Polygon", "coordinates": ["@@ñȄυƦöŐƩóנƨƨφ@@Ő̏Ʀ@Ő̑ôƨŌנóɜôƪŋɜŌѶօڔə݈òɞōɜŎôӏƦóƨô̒óôȃƨó̎ŐôƧƪ@ƨȁςƧə̑̎Н@̍Ƨŏρôԭͩԫ̍ʵƧóȀôɞƧŌ@ŐѹͩñòɞñɛǿƩɛñρͪ߻Ȃ̑ŏƪəƩóםôõŏƧ@ɛНƥȄó̑ѺƧôφóƨƨƦƪóɜŐôóòôƨóφ̐ƨóƦ̎"], "encodeOffsets": [[112860, 31905]] } }, { "type": "Feature", "id": "gui_zhou", "properties": { "name": "贵州", "cp": [106.6113, 26.9385], "childNum": 9 }, "geometry": { "type": "Polygon", "coordinates": ["@@ɜȀƦŋԮô̒ɚôōעƪƧʴɝ@ɛʶ̒ʶ̐ȁƦóȂô@ôŏ@ōôƨʶѸô@ʶƨɞó@ōτöòυƨ@@əƨô@ɛ̒@Ʀɜôȃ@̍ôʵԩНôóςŌƨŋ@ȃƧñôŏƧɛƨôɝƧʵ̍ôȃυ@ɝɛȂƥóóȁɛóõôɛ@əͪɛŋôȁƩóםȃ@ƥƧŏړʶѹ̍ƥŌƦȂóôɜƨѵО̎נəɜѹŋƧȂ@ȀóɜͪɞƧ"], "encodeOffsets": [[106651, 27901]] } }, { "type": "Feature", "id": "shan_dong", "properties": { "name": "山东", "cp": [118.7402, 36.4307], "childNum": 17 }, "geometry": { "type": "Polygon", "coordinates": ["@@Ʃ̐φͪɚςɞ@@Ȃƨñ̎̎Ԯ@ѶОƨƧڔ@φН̑ŋ@Ʃ̒ǿ̎@ƨɜԬςôʶ̐ʶöԫƨƧנƥɜŎôō̎@ôŏóρƧŏԫôóƧԩó@ƥɜƧԭóƨʵɛƨ߻ӑɜНԩóô̑óƧʳəóɛƧ@õȀƧ̍ȃɛŐóŏυО̍óɝƩԩ@ƧɚԫȄɚʶƨɞʶԪ̐ړɛƪ̒"], "encodeOffsets": [[118261, 37036]] } }, { "type": "Feature", "id": "jiang_xi", "properties": { "name": "江西", "cp": [116.0156, 27.29], "childNum": 11 }, "geometry": { "type": "Polygon", "coordinates": ["@@ƧȄôɚəȄ̎ʶԬԮͪςóƨŐƪτɞƦōƥƧ@ŏςôóŐôô̒ʷѶƪƩƩǿ@ō̒ɛôυ@Ƨȁѹɛəƨѹ̑ƨ̏óƥѵʷô̍ɛȁôŏɝǿƧԫƧôʳƥōòȃρȄ߻ɛɝƨɞɚɜƨôŐƧŎԭōñƦòԮɜôɛôͪƥ@ʶƧƨôƦƧô@Ȅô̎Ѷͪ"], "encodeOffsets": [[117000, 29025]] } }, { "type": "Feature", "id": "he_nan", "properties": { "name": "河南", "cp": [113.4668, 33.8818], "childNum": 17 }, "geometry": { "type": "Polygon", "coordinates": ["@@φ̎ƪ̐ɞȄɚ@@Ȃעó̎ŌѺ̒ôֆॢȃôƨŎƨōƪöƩ̑ڔɜԩ̏ɝʵƧəʵԬȃƨəԪ@@Ƨ̒ŏô̍υȁƧɚ̍ôóŋ@ɝƧŋõ̑σ@ŏɜŋôɝ̒ƧɚôôطρóóɛƩ@óƨ̍ŏƧôóȄ̑ôƧóƥôóӐɛōɝŎ݇ñړɚѵֆ@ɞ̏ʶ@ʴƩöó̐"], "encodeOffsets": [[113040, 35416]] } }, { "type": "Feature", "id": "liao_ning", "properties": { "name": "辽宁", "cp": [122.3438, 41.0889], "childNum": 14 }, "geometry": { "type": "Polygon", "coordinates": ["@@ƨʴƧôôӔƨô̎ƩɞН̎ͪ߼ͪɜɞɚ̐@ƨςŏ̒ôƦƨɜô̎ƪôςǿƨͩɞȀƨ@@ɛςփôóŋ@ʵφυƩʳö॥փρѹס@əɛ@ͩࢯ@ѹʵρƩʶφȀƧ݈̒۬óʸɝŎѵ@ԭԫןɛƧƨƥςɛυʶφО"], "encodeOffsets": [[122131, 42301]] } }, { "type": "Feature", "id": "shan_xi_2", "properties": { "name": "山西", "cp": [112.4121, 37.6611], "childNum": 11 }, "geometry": { "type": "Polygon", "coordinates": ["@@ɚѺñŌɚôȄѺ̎ֆφóςȂ̒ɜƨɚ@@Ȁƨŋôȃƪѹ̑̐ŋƪ̑Ʃρρóó@ōɛɛ@əɜŏƦρƨρѵ@ɝɛǿɜʵóօѹ̑̍ŋסô@ȁə@ɝȃ̏̍ƩυƧô@Ȃ̐ظóОó݊φք̑ʸ@Ȃ̒ʶôȀ"], "encodeOffsets": [[113581, 39645]] } }, { "type": "Feature", "id": "an_hui", "properties": { "name": "安徽", "cp": [117.2461, 32.0361], "childNum": 17 }, "geometry": { "type": "Polygon", "coordinates": ["@@ó̎̑Ő@ƨƪѶǿɜ̑φƦʵ̐ƧѵôóƪôôυςƨȂɞŏ@̍ԫôò̑ƥóȃѶͩƧƥôŏѺôŏƦ@ƥͩƧôȁυó@̑ƧɛѵʵƩƪѵ̑ʸóóôŏρó@ŐƦƨƥŎσɝƩ@̎̍Оɚ̒ρƨƧȂôɜςôóظəó̑ƨóɞɛŌ@Őτö̒ƨŌ@ɞôŌ̎óƨəφȂ"], "encodeOffsets": [[119431, 34741]] } }, { "type": "Feature", "id": "fu_jian", "properties": { "name": "福建", "cp": [118.3008, 25.9277], "childNum": 9 }, "geometry": { "type": "Polygon", "coordinates": ["@@̎óȁƨӑ̒̎ɚƨͩφŐƨɝ̎ŋóŏρ@ōƨòʳəóƨō̏õɛƧ@ƨѵƧōəŏóŋƧô̑ɝɛʳƥ@@óɛõ@Ƨ̑ƧóȁəƧ̑Ƨ̐@ɚəОƧƧɚóñ̑ŎóʴƨƨԬɞȀóŐɜȂó̎ѶʸôƦƧ̐Ѻ̒ɚƧѺɜƨȂ"], "encodeOffsets": [[121321, 28981]] } }, { "type": "Feature", "id": "zhe_jiang", "properties": { "name": "浙江", "cp": [120.498, 29.0918], "childNum": 11 }, "geometry": { "type": "Polygon", "coordinates": ["@@Ѷʶƨɜ@̒φôóȂƨƦͪ@̐Ѹ̍τȂ̒̑נŐמôƪƧôӑ̑@ƥρͩƨօ̏@@υɝó@ŋɛ@ôƩəóƧѵυó@ƩɜŋƧ@̍ŌƧɞυŏƧͪ̍ə̑ƧӒôȂ̍@óφ̑ɜ@ŎƪȀ"], "encodeOffsets": [[121051, 30105]] } }, { "type": "Feature", "id": "jiang_su", "properties": { "name": "江苏", "cp": [120.0586, 32.915], "childNum": 13 }, "geometry": { "type": "Polygon", "coordinates": ["@@ôɞ̎φНôŐɜŏ̎Ȅƨöǿƨ@ôɜɚƨʴ̒ôôó@Ƨ̎əԮȃԪૉöͩ̐ƧòʵφƧôʵ@óړɜóŏɜǿƧɝρσȁѷ̎̏ƥóŐѹóŐƨƦѵͪôȄƦñ̒Ԭó@̎ɝŐƧȁρóφƩóóôƨѶ̏ƥʶυɛ̒ѵȀ"], "encodeOffsets": [[119161, 35460]] } }, { "type": "Feature", "id": "chong_qing", "properties": { "name": "重庆", "cp": [107.7539, 30.1904], "childNum": 40 }, "geometry": { "type": "Polygon", "coordinates": ["@@əȂòɜƨѺɛƦȁ̐@ƪõŏφƥòȃƥ̍Ƨôυ̏ƧôñóóôɛŏƩôƧƥôƧóυƨ̒ѹôƦȃ@փƥɛ̑@@ɜƧó@ɚƧ@ñφσõ@ŎɝôƧ@ʵѷóƧʵó@ŎóŐó@ôȁƥó̒υôóʶəƧȄς̎ƧȂôƨƨƨφɛ̎Őƨʷɞ@ςԮóŌôôφ@ɜֈ̎ƨ"], "encodeOffsets": [[111150, 32446]] } }, { "type": "Feature", "id": "ning_xia", "properties": { "name": "宁夏", "cp": [105.9961, 37.3096], "childNum": 5 }, "geometry": { "type": "Polygon", "coordinates": ["@@ల̒ôޠφӒςôƪͧυևɜŋѺó̎ȁ̍ɛ@ѹס@@ʵƧȁôó@ǿ̐ŏöʵɝŋɛ@ô̑ƥóóƨƧóôó@ƩôóƦ̍óȀƨŎɛӒôŐυͪɛ@@Ȁə@"], "encodeOffsets": [[106831, 38340]] } }, { "type": "Feature", "id": "hai_nan", "properties": { "name": "海南", "cp": [109.9512, 19.2041], "childNum": 18 }, "geometry": { "type": "Polygon", "coordinates": ["@@φɜƦʶ̐ôφô̎@ƨŎö@τʵƦԩ۫õН̏óƥȃƧ@Ʃəםƨ̑Ʀ@ޤ"], "encodeOffsets": [[111240, 19846]] } }, { "type": "Feature", "id": "tai_wan", "properties": { "name": "台湾", "cp": [121.0254, 23.5986], "childNum": 1 }, "geometry": { "type": "Polygon", "coordinates": ["@@ôƩɝöƧɝѵəޣ̏ρƩԭóōóͪρɞƧОôԪ݈ଦѶɜ̒ɛ"], "encodeOffsets": [[124831, 25650]] } }, { "type": "Feature", "id": "bei_jing", "properties": { "name": "北京", "cp": [116.4551, 40.2539], "childNum": 19 }, "geometry": { "type": "Polygon", "coordinates": ["@@óóóυóôƥ@ŏóóə@ƧŋƩŌρóɛŐóʶѶʴƥʶ̎ôƨɞ@óŎɜŌ̎̍φƧŋƨʵ"], "encodeOffsets": [[120241, 41176]] } }, { "type": "Feature", "id": "tian_jin", "properties": { "name": "天津", "cp": [117.4219, 39.4189], "childNum": 18 }, "geometry": { "type": "Polygon", "coordinates": ["@@ôôɜ@ƨöɚôôôɚŏ@óƥ@@ȁƦƧɜ@óƧƨƥ@ƧóəН̏óѷɜ@ŎƦƨóО"], "encodeOffsets": [[119610, 40545]] } }, { "type": "Feature", "id": "shang_hai", "properties": { "name": "上海", "cp": [121.4648, 31.2891], "childNum": 19 }, "geometry": { "type": "Polygon", "coordinates": ["@@ɞςƨɛȀôŐڔɛóυô̍ןŏ̑̒"], "encodeOffsets": [[123840, 31771]] } }, { "type": "Feature", "id": "xiang_gang", "properties": { "name": "香港", "cp": [114.2578, 22.3242], "childNum": 1 }, "geometry": { "type": "Polygon", "coordinates": ["@@óɛƩ@ρ@óôȀɚŎƨ@ö@@ōƨ@"], "encodeOffsets": [[117361, 22950]] } }, { "type": "Feature", "id": "ao_men", "properties": { "name": "澳门", "cp": [113.5547, 22.1484], "childNum": 1 }, "geometry": { "type": "Polygon", "coordinates": ["@@X¯aWĀ@l"], "encodeOffsets": [[116325, 22697]] } }], "UTF8Encoding": true });
// import elTree2 from '@/../plugins/tree/src/tree.vue'
echarts.registerMap('china', test);

import magic from "@/../static/common/magic.js";

export default {
    props:{

    },
    components:{
        Header,
        Footer,
        // elTree2
    },
    data(){
        return {
            //选择数据
            searchData:{
                select:[],//下拉框选项数据
                value: '',
                quarter:[],//季度下拉框数据
                quarterValue: '',
            },
            //选择字段
            searchText:{
                canSelect: [],//可选股票
                checkAll: false,
                checkedCities:[],//可选股票的默认选中
                isIndeterminate: false,//可选股票的默认选中
                choosedItems:''//选中的字段
            },
            //股票搜索数据
            search:{
                state:'',//搜索输入框状态
                canSelect: [],//可选股票
                checkAll: false,
                checkedCities:[],//可选股票的默认选中
                isIndeterminate: false,//可选股票的默认选中
                treeeData: [],//股票搜索树形图数据
                defaultProps: {
                    children: 'children',
                    label: 'lable'
                },
                choosedTreeNode: [],//树形图选中项
                fileList: [], //上传文件列表
                uploadUrl: window.baseUrl + '/listCcompany/uploadFile',
                choosedItems:''//选中的股票
            },
            //图形数据
            graph:{
                count1:[],//上海证券交易所数据
                count2:[],//深圳证券交易所数据
                tabBool:true,//tab切换
                tableData: [],
                tableOrderData:[],//表格有排序的集合
                tableColumnWidth:[],//表格各个列最大宽度
                creditCodes:{},//获取点击每一个股票的creditCodes信息
                offset:0,//page
                limit:15,
                total:0,
                currentPage:1,
                boolTable: false,//判断当前表格是全局渲染还是条件搜索渲染
                defaultTable: true,//判断当前是默认表格还是筛选表格
                orderByCode:'',
                orderNum: 1,
                loading:false //tableloading状态
            }
        }
    },
    watch: {
      // search:{
      //   handler(val, oldVal){
      //       console.log(val.checkedCities, oldVal.checkedCities,'val1');
      //       console.log(val.selected,'val.selected1')
      //   },
      //   deep:true //true 深度监听
      // }
    },
    methods:{
        //选择股票--按钮弹出事件--------搜索开始-----------------
        //下载函数
        downloadFn(incomeType){
            let _this = this;
            //判断是否有权限，是否登录
            window.that = this;
            magic.loginOrRights(0).then((res)=>{
                if(!res){
                    _this.$message.error('请您登录！');
                    return;
                }
                if(res && res.rights == 0){
                    _this.$message.error('您没有权限！');
                    return;
                }

                let data = {};
                if(_this.graph.boolTable){//条件搜索
                    let str = '';
                    let tmpArr = _this.searchText.choosedItems.split(',');

                    for(let i=0;i<_this.searchText.canSelect.length;i++){
                        for(let j=0;j<tmpArr.length;j++){
                            if(tmpArr[j] == _this.searchText.canSelect[i].indicatorName){
                                str += _this.searchText.canSelect[i].indicatorCode + ',';
                            }
                        }
                    }
                    str = str.substring(0,str.length-1);
                    let timeStr = '';
                    for(let i=0;i<_this.searchData.quarterValue.length;i++){
                        timeStr += _this.searchData.quarterValue[i] + ',';
                    }
                    data={
                        stockCodes: _this.search.choosedItems,//股票代码
                        reportDate: timeStr,//日期报告
                        dataCode: _this.searchData.value,//数据编码
                        indicatorCodes: str,//选择字段
                        orderRule: 0,//排序规则 0:降序 1:升序
                        orderByCode: 'company_stock_code',//排序编码
                    }
                }else{//全局加载
                    data={
                        stockCodes: '',//股票代码
                        reportDate: '',//日期报告
                        dataCode: 0,//数据编码
                        indicatorCodes: '',//选择字段
                        orderRule: 0,//排序规则 0:降序 1:升序
                        orderByCode: 'company_stock_code',//排序编码
                    }
                }
                
                _this.downloadTableFiles(window.baseUrl + '/listCcompany/downComparativeData?stockCodes=' + data.stockCodes + '&reportDate=' + data.reportDate + '&dataCode=' + data.dataCode + '&indicatorCodes=' + data.indicatorCodes + '&orderRule=' + data.orderRule + '&orderByCode=' + data.orderByCode); 

                // 埋点
                try{
                    //LogCollection.contents["key"]="value";
                    //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
                    //2：收藏
                    //3：下载
                    //4：分享
                    //5：购买
                    //6：登录
                    //7：注册
                    //9：搜索
                    //10：复制
                    //11：点赞
                    //12：评论
                    LogCollection.send(3);
                }catch(e){}
            });
        },
        downloadTableFiles(url) {
            console.log(url,'url')
            let a = document.createElement('a');
            a.href = url;
            let _id = Math.random()+Math.random();
            a.id = _id;
            a.click();
            window.URL.revokeObjectURL(url);
        },
        changeDateFn(val){
            // console.log(val,'test');
            if(val.length == 5){
                this.$message({
                    message: '您选的参数总数已达到上限！',
                    type: 'warning'
                });
            }
        },
        //表格点击排序
        sortChangeFn(column, prop, order){
            console.log(column, prop, order,'sort');
            // 点击时先升序ascending,再点击降序descending
            let orderNum = column.order == 'ascending' ? 1 : 0;
            let context = column.column.label;
            let orderByCode = '';
            let arr = this.graph.tableOrderData;
            for(let i = 0; i < arr.length; i++){
                if(context === arr[i].name){
                    orderByCode = arr[i].code;
                }
            }
            console.log(orderByCode,'orderByCode');
            this.graph.orderByCode = orderByCode;
            this.graph.orderNum = orderNum;

            if(this.graph.defaultTable){//
                this.searchAllBtn(1,1);//加载默认表格数据
            }else{
                this.searchAllBtnLogin(0);//加载筛选数据
            }

        },
        //判断元素是否在数组里面
        isInArray(arr,value){
            for(let i = 0; i < arr.length; i++){
                if(value === arr[i].name){
                    return true;
                }
            }
            return false;
        },
        //点击表格股票
        cellClickFn(row, column, event){
            let _this = this;
            //判断是否有权限，是否登录
            window.that = this;
            magic.loginOrRights(0).then((res)=>{
                console.log(res,'bool')
                if(!res){
                    that.$message.error('请您登录！');
                    return;
                }
                if(res && res.rights == 0){
                    that.$message.error('您没有权限！');
                    return;
                }
                let index = row.index;
                if(row[1] == event.target.innerText && event.target.innerText != '股票名称'){
                    if(Object.keys(_this.graph.creditCodes).length){
                        let tmpObj = this.graph.creditCodes;
                        for(let item in tmpObj){
                            if(row[0] == item){
                                let routeData = _this.$router.resolve({ path:'/stock/2/baseinfo', query: { creditCode: tmpObj[item] }});

                                window.open(routeData.href, '_blank');
                            }
                        }
                    }
                }
                if(row[0] == event.target.innerText && event.target.innerText != '股票代码'){
                    if(Object.keys(_this.graph.creditCodes).length){
                        let tmpObj = _this.graph.creditCodes;
                        for(let item in tmpObj){
                            if(row[0] == item){
                                let routeData = _this.$router.resolve({ path:'/stock/2/baseinfo', query: { creditCode: tmpObj[item] }});
                                window.open(routeData.href, '_blank');
                            }
                        }
                    }
                }
            });
        },
        //table的单元格样式
        cellStyle(row, column, rowIndex, columnIndex){
            //styles
            let _this = this;
            if(row.columnIndex == 1 && row.rowIndex > 0){
                return 'color:rgb(53, 131, 237);cursor: pointer;'
            }
            if(row.columnIndex == 0 && row.rowIndex > 0){
                return 'color:rgb(53, 131, 237);cursor: pointer;'
            }
            if(row.rowIndex == 0){
                return 'color: #333333;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;display:none;'
            }
        },
        // 分页函数
        handleCurrentChange(val) {//当前页
            this.graph.currentPage = val;
            this.graph.offset = (val-1)*this.graph.limit;
            this.graph.boolTable ? this.searchAllBtn(0,0) : this.searchAllBtn(1,0);
        },
        //下载文件
        downloadFiles(){
            this.download('@/../static/common/files/demo1.txt', '股票代码示例文件');
            setTimeout(()=>{this.download('@/../static/common/files/demo2.txt', '示例说明');},300)
        },
        //文件下载
        download(url, filename) {
            return fetch(url).then(res => res.blob().then(blob => {
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }))
        },
        //筛选查询按钮登录和权限判断
        searchAllBtnLogin(num){
            //判断是否有权限，是否登录
            window.that = this;
            magic.loginOrRights(0).then((res)=>{
                if(!res){
                    that.$message.error('请您登录！');
                    return;
                }
                if(res && res.rights == 0){
                    that.$message.error('您没有权限！');
                    return;
                }
                if(num == 1){//当点查询按钮时
                    that.graph.orderNum = 1;//排序规则 0:降序 1:升序
                    that.graph.orderByCode = "company_stock_code";//排序编码
                    // 埋点
                    try{
                        //LogCollection.contents["key"]="value";
                        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
                        //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
                        LogCollection.send(9);
                    }catch(e){}
                }
                that.graph.loading = true;//添加loading
                that.graph.currentPage = 1;
                that.searchAllBtn(0,1);
            });
        },
        //查询按钮触发函数
        searchAllBtn(_num = 0, initalPage = 0){
            let _this = this;
            let str = '';
            let _data = {};
            this.graph.loading = true;//添加loading
            if(!_num){//第一次加载不加这两个字段
                let tmpArr = _this.searchText.choosedItems.split(',');
                this.graph.boolTable = true;

                if(initalPage){//判断是否初始化页码1为初始化，0为不初始化
                    _this.graph.offset = 0;
                    _this.graph.defaultTable = false;
                }
            
                if(!_this.search.choosedItems){
                    this.$message.error('请选择股票代码！');
                    return;
                }
                if(!_this.searchText.choosedItems){
                    this.$message.error('请选择字段！');
                    return;
                }
                for(let i=0;i<_this.searchText.canSelect.length;i++){
                    for(let j=0;j<tmpArr.length;j++){
                        if(tmpArr[j] == _this.searchText.canSelect[i].indicatorName){
                            str += _this.searchText.canSelect[i].indicatorCode + ',';
                        }
                    }
                }
                str = str.substring(0,str.length-1);
                let timeStr = '';
                for(let i=0;i<_this.searchData.quarterValue.length;i++){
                    timeStr += _this.searchData.quarterValue[i] + ',';
                }
                
                _data = {
                    stockCodes: _this.search.choosedItems,//股票代码
                    reportDate: timeStr,//日期报告
                    dataCode: _this.searchData.value,//数据编码
                    indicatorCodes: str,//选择字段
                    orderRule: _this.graph.orderNum,//排序规则 0:降序 1:升序
                    orderByCode: _this.graph.orderByCode ? _this.graph.orderByCode : "company_stock_code",//排序编码
                    offset:_this.graph.offset,//多少条开始
                    limit:_this.graph.limit//条数
                }
                _this.graph.tabBool = false;//点击查询，切换到表格
                $('.graphTab1').css('background','#f4f4f4');
                $('.graphTab2').css('background','#fff');
            }else{
                this.graph.boolTable = false;//给分页一个信号
                _data = {
                    dataCode:0,
                    indicatorCodes:"",
                    orderRule:_this.graph.orderNum,
                    orderByCode:_this.graph.orderByCode ? _this.graph.orderByCode : "company_stock_code",
                    offset:_this.graph.offset,//多少条开始
                    limit:_this.graph.limit//条数
                }
            }
            console.log(_data,'_data')
            $.ajax({
                 type: "POST",
                 url: window.baseUrl + '/listCcompany/getComparativeData',
                 data: JSON.stringify(_data),
                 dataType: "json",
                 contentType:'application/json',
                 success: function(data){
                    _this.graph.tableData = data.data.rows;
                    _this.graph.tableOrderData = data.data.orderData;
                    _this.graph.creditCodes = data.data.creditCodes;
                    _this.graph.total = data.data.total;
                    console.log(data.data.rows,'data');
                    _this.getMaxTableWidthFn(data.data.rows);
                    setTimeout(()=>{
                        _this.graph.loading = false;//取消loading
                    },1000);
                }
            });
        },
        //获取表格每一列的文字最大长度
        getMaxTableWidthFn(data){
            let _this = this;
            let tmpLen = Object.keys(data[0]).length;
            let arr = [];
            for(let i=0;i<tmpLen;i++){
                arr.push([]);
            }
            for(let i=0;i<data.length;i++){
                for(let item in data[i]){
                    let len = _this.chkstrlen(String(data[i][item]));
                    arr[item].push(len);
                }
            }
            _this.graph.tableColumnWidth = [];
            for(let i=0;i<arr.length;i++){                
                _this.graph.tableColumnWidth.push(Math.max(...arr[i]));
            }
            // console.log(_this.graph.tableColumnWidth,'widthArr');
        },
        //判断是否是汉字
        chkstrlen(str){
            let strlen = 0;
            for(let i = 0;i < str.length; i++){
                if(str.charCodeAt(i) > 255){ //如果是汉字，则字符串长度加2
                    strlen += 2;
                }else{
                    strlen++;
                }
            }
            return strlen;
        },
        //上传文件
        successUpload(response, file, fileList, $event){
            let _this = this;
            if(response.message == 'success' && response.data[0]){
                if(response.data.length > 0){
                    for(let i=0;i<response.data.length;i++){
                        let len = _this.search.checkedCities.length;
                        _this.search.checkedCities.push(response.data[i].stockName);

                        let newArr = Array.from(new Set(_this.search.checkedCities));//去重

                        if(newArr.length > len){
                            _this.search.choosedItems += response.data[i].stockName.substring(0,6) + ',';
                        }else{
                            _this.search.checkedCities = newArr;
                        }
                    }
                }
                this.$refs.upload.clearFiles();//清空上传的文件
            }
        },
        //获取树形图数据
        fetchTreeData(){
            let _this = this;
            api.upmarketsearchTree().then(res=>{
                let data = res.data;
                console.log(data,'data11')
                // data[0].showCheckbox = false;
                _this.search.treeeData = data;
            })   
        },
        //选择股票--树形图点击事件
        handleNodeClick(data,dataAll){
            let _this = this;
            let data2 = dataAll.checkedNodes;
            let tmpArr = [];
            let str = '';
            for(let i=0;i<data2.length;i++){
                if(!data2[i].children){
                    tmpArr.push({
                        classId: data2[i].classId,
                        searchId: data2[i].searchId,
                        lable: data2[i].lable
                    });
                    str += data2[i].searchId + ':' + data2[i].classId + ';'
                }
            }
            this.search.choosedTreeNode = tmpArr;
            api.upmarketsearchById(str).then(res=>{
                let data = res.data;
                _this.search.canSelect = data;
            })  
        },        
        //打开股票选择弹框
        chooseUpMarket(){
            //判断是否有权限，是否登录
            this.graph.tabBool = false;//切换tab选项
            $('.graphTab1').css({'background':'#f4f4f4','color':'#67696B'});
            $('.graphTab2').css({'background':'#fff','color':'#3583ED'});
            window.that = this;
            magic.loginOrRights(0).then((res)=>{
                if(!res){
                    that.$message.error('请您登录！');
                    return;
                }
                if(res && res.rights == 0){
                    that.$message.error('您没有权限！');
                    return;
                }
                let bools = $('.box-card_one').css('display');
                bools == 'none' ? $('.box-card_one').css('display','block') : $('.box-card_one').css('display','none');
            });
        },
        //删除所有已选股票
        removeClickedUpMarketFn(){
            this.search.checkedCities = [];
            this.search.checkAll = false;
        },
        //删除所有已选字段
        removeClickedUpMarketFn2(){
            this.searchText.checkedCities = [];
            this.searchText.checkAll = false;
        },
        //删除单个已选股票
        removeOneSelectedUpMarketFn(item){
            let data = this.search.checkedCities;
            Array.prototype.remove = function(val) { //删除数组里某一个元素
                var index = this.indexOf(val); 
                if (index > -1) { 
                    this.splice(index, 1); 
                } 
            };
            setTimeout(()=>{
                this.search.checkedCities.remove(item);
            },300);
        },
        //删除单个已选字段
        removeOneSelectedUpMarketFn2(item){
            let data = this.searchText.checkedCities;
            Array.prototype.remove = function(val) { //删除数组里某一个元素
                var index = this.indexOf(val); 
                if (index > -1) { 
                    this.splice(index, 1); 
                } 
            };
            setTimeout(()=>{
                this.searchText.checkedCities.remove(item);
            },300);
        },
        //搜索股票输入框
        querySearch() {
            // e.stopPropagation();
            // e.preventDefault();
            let _this = this;
            this.$forceUpdate();
            if(!this.search.state){
                return;
            }
            let searchName = this.search.state;
            api.upmarketsearchMarket(searchName).then(res=>{
                let data = res.data;
                _this.search.canSelect = data;
                return false
            })   
        },
        //选择股票--确定按钮
        searchUpmarketBtn(){
            $('.box-card_one').css('display','none');
            let str = '';
            let data = this.search.checkedCities;
            for(let i=0;i<data.length;i++){
                str += data[i].substring(0,6) + ',';
            }
            this.search.choosedItems = str;
            this.search.state = '';
        },
        //在页面点击后关闭股票提示框
        bodyCloseAlert(){
            $('.home').off('click').on('click',(e)=>{           
                if($( e.target ).closest(".box-card_one").length == 0){
                    $('.box-card_one').css('display','none');
                }

                if($( e.target ).closest(".box-card_two").length == 0){
                    $('.box-card_two').css('display','none');
                }
            })
        },
        //选择股票--全选
        handleCheckAllChange(val) {
            let _this = this;
            if(val){
                this.search.checkedCities = [];
                let select = this.search.canSelect;
                for(let i=0;i<select.length;i++){
                    _this.search.checkedCities.push(select[i].stockName);
                }
            }else{
                this.search.checkedCities = [];
            }
            this.search.isIndeterminate = false;
        },
        //选择字段--全选
        handleCheckAllChange2(val) {
            let _this = this;
            if(val){
                this.searchText.checkedCities = [];
                let select = this.searchText.canSelect;
                for(let i=0;i<select.length;i++){
                    _this.searchText.checkedCities.push(select[i].indicatorName);
                }
            }else{
                this.searchText.checkedCities = [];
            }
            this.searchText.isIndeterminate = false;
        },
        //选择股票--每一个成员被选中后，全选按钮自动改变
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.search.checkAll = checkedCount === this.search.canSelect.length;
            this.search.isIndeterminate = checkedCount > 0 && checkedCount < this.search.canSelect.length;

        },
        //选择字段--每一个成员被选中后，全选按钮自动改变
        handleCheckedCitiesChange2(value) {
            let checkedCount = value.length;
            this.searchText.checkAll = checkedCount === this.searchText.canSelect.length;
            this.searchText.isIndeterminate = checkedCount > 0 && checkedCount < this.searchText.canSelect.length;

        },
        //选择字段--弹出按钮事件
        chooseTextFn(){
            //判断是否有权限，是否登录
            this.graph.tabBool = false;//切换tab选项
            $('.graphTab1').css({'background':'#f4f4f4','color':'#67696B'});
            $('.graphTab2').css({'background':'#fff','color':'#3583ED'});
            window.that = this;
            magic.loginOrRights(0).then((res)=>{
                if(!res){
                    that.$message.error('请您登录！');
                    return;
                }
                if(res && res.rights == 0){
                    that.$message.error('您没有权限！');
                    return;
                }
                let bools = $('.box-card_two').css('display');
                bools == 'none' ? $('.box-card_two').css('display','block') : $('.box-card_two').css('display','none');
            });
        },
        //选择字段--下拉框数据获取
        searchTextFetchSelectFn(){
            let _this = this;
            api.upmarketsearchTextSelect().then(res=>{
                let data = res.data;
                if(data.length == 0){
                    return;
                }
                for(let i=0;i<data.length;i++){
                    _this.searchData.select.push({
                        value: data[i].dataCode,
                        label: data[i].dataName
                    });
                }
                _this.searchData.value = data[0].dataCode;//默认选第一个
                _this.searchTextSelectFn(data[0].dataCode);//选择字段初始化第一个列表
            })   
        },
        //选择字段--下拉框触发函数
        searchTextSelectFn(val){
            let _this = this;
            api.upmarketsearchTextGetList(val).then(res=>{
                let data = res.data;
                this.searchText.canSelect = [];
                this.searchText.checkedCities = [];
                this.searchText.choosedItems = '';
                this.searchText.checkAll = false;
                for(let i=0;i<data.length;i++){
                    this.searchText.canSelect.push({
                        indicatorName: data[i].indicatorName,
                        indicatorId: data[i].indicatorId,
                        indicatorCode: data[i].indicatorCode
                    });
                }
            });
            if(val > 0){
                this.searchData.quarter = [];
                this.searchData.quarterValue = '';
                api.upmarketsearchTextSelectTime(val).then(res=>{
                    let data = res.data;
                    for(let i=0;i<data.length;i++){
                        this.searchData.quarter.push({
                            label: data[i].aliasName,
                            value: data[i].reportDate
                        });
                    }
                });
            }else{
                this.searchData.quarter = [];
                this.searchData.quarterValue = '';
            }
        },
        //选择字段--确定按钮
        searchTextBtn(){
            $('.box-card_two').css('display','none');
            let str = '';
            let data = this.searchText.checkedCities;
            for(let i=0;i<data.length;i++){
                str += data[i] + ',';
            }
            this.searchText.choosedItems = str;
        },
        
        //-------------------------搜索结束-----------------------------
        //tab切换按键
        graphTabFn(val){
            if(val == 1){
                $('.graphTab1').css({'background':'#fff','color':'#3583ED'});
                $('.graphTab2').css({'background':'#f4f4f4','color':'#67696B'});
                this.graph.tabBool = true;
            }else{
                $('.graphTab1').css({'background':'#f4f4f4','color':'#67696B'});
                $('.graphTab2').css({'background':'#fff','color':'#3583ED'});
                this.graph.tabBool = false;
            }
        },
        //可视化--上市公司总数
        echartsAllCount(){
            let myChart = echarts.init(document.getElementById("upmarket_allcount"));
            let option = {
                tooltip: {
                    show: true,
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    left: 10,
                    data: []
                },
                series: [
                    {
                        name: '上市公司总数',
                        type: 'pie',
                        radius: ['50%', '70%'],
                        avoidLabelOverlap: false,
                        hoverAnimation: true,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '30',
                                fontWeight: 'bold'
                            },
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            // {value: 335, name: '直接访问'}
                        ]
                    }
                ]
            };
            
            api.upmarketAllCount().then(res=>{
                let _data = res.data;
                option.series[0].data = _data;
                console.log(_data,'_data')
                let tmpData = [];
                if(_data.length > 0){
                    for(let i=0;i<_data.length;i++){
                        tmpData.push(_data[i].name);
                    }
                    option.legend.data = tmpData;
                }
                if (option && typeof option === "object") {
                    myChart.setOption(option, true);

                }
            })
        },
        //可视化--上市公司区域分布图
        echartsMap(){
            let myChart = echarts.init(document.getElementById('upmarket_echarts_map'));
            let optionMap = {  
                backgroundColor: '#FFFFFF',  
                title: {  
                    show:false,
                    text: '上市公司区域分布图',  
                    subtext: '',  
                    x:'center'  
                },  

                tooltip : {  
                    trigger: 'item',
                    enterable: true,
                    triggerOn: 'click',//只有点击事件才出现
                    formatter: function(params){
                        
                        var html = '';
                        
                        return html
                    },  
                },  
                
                //左侧小导航图标
                visualMap: {  
                    show : true,  
                    x: 'left',  
                    y: 'bottom',  
                    // min: 0,
                    // max: 100, 
                    inRange: {
                        color: ["#8ACFF2", "#C8FF5F", "#FFED24","#FF4800"],
                    }
                },  
                //配置属性
                series: [{  
                    name: '上市公司区域分布图',  
                    type: 'map',  
                    mapType: 'china',   
                    roam: false,  
                    zoom: 1.2,
                    label: {  
                        normal: {  
                            show: true  //省份名称  
                        },  
                        emphasis: {  
                            show: false,

                        }  
                    },  
                    data:[]  //数据
                }]  
            }; 
            api.upmarketMap().then(res=>{
                let _data = res.data;
                optionMap.series[0].data = _data;
                if (optionMap && typeof optionMap === "object") {
                    myChart.setOption(optionMap);
                    window.onresize = myChart.resize;
                }
            })
        },
        //可视化--上市公司数量
        echartsUpmarketNum(){
            let myChart = echarts.init(document.getElementById('upmarket_echarts_num'));
            let option = {
                color: ['#3398DB'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                yAxis: [
                    {
                        axisLine: {show:false},//去掉线
                        axisTick: {show:false},//去掉点
                        type: 'category',
                        data: [],
                        // axisTick: {
                        //     alignWithLabel: true
                        // }
                    }
                ],
                xAxis: [
                    {
                        type: 'value',
                        show:false
                    }
                ],
                series: [
                    {
                        name: '上市公司数量',
                        type: 'bar',
                        barWidth: '30%',
                        data: [],
                        itemStyle: {
                            normal: {
                               label: {
                                   show: true,      //开启显示
                                   position: 'right', //在上方显示
                                   textStyle: {     //数值样式
                                       color: 'black',
                                       fontSize: 16
                                   }
                               }
                            }
                        }

                    }
                ]
            };
            api.upmarketMap().then(res=>{
                let _data = res.data;
                option.series[0].data = _data;
                let tmpData = [];
                if(_data.length > 0){
                    for(let i=0;i<_data.length;i++){
                        tmpData.push(_data[i].name);
                    }
                    option.yAxis[0].data = tmpData;
                }
                if (option && typeof option === "object") {
                    myChart.setOption(option);
                    window.onresize = myChart.resize;
                }
            })
        },
        //可视化--上市公司新增数量随时间分布情况
        echartsUpmarketTimeNum(){
            let myChart = echarts.init(document.getElementById('upmarket_echarts_timeNum'));
            let option = {
                color: ['#3398DB'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        axisLine: {show:true},//去掉线
                        axisTick: {show:false},//去掉点
                        type: 'category',
                        data: [],
                        splitLine:{//去网格线
                            show:false
                        }
                        // axisTick: {
                        //     alignWithLabel: true
                        // }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        show:true,
                        splitLine:{//去网格线
                            show:false
                        }
                    }
                ],
                series: [
                    {
                        name: '上市公司新增数量随时间分布情况',
                        type: 'bar',
                        barWidth: '30%',
                        data: [],
                        itemStyle: {
                            normal: {
                               label: {
                                   show: false,      //开启显示
                                   position: 'top', //在上方显示
                                   textStyle: {     //数值样式
                                       color: 'black',
                                       fontSize: 16
                                   }
                               }
                            }
                        }

                    }
                ]
            };
            
            api.upmarketTimeNum().then(res=>{
                let _data = res.data;
                option.series[0].data = _data;
                let tmpData = [];
                if(_data.length > 0){
                    for(let i=0;i<_data.length;i++){
                        tmpData.push(_data[i].name);
                    }
                    option.xAxis[0].data = tmpData;
                }
                if (option && typeof option === "object") {
                    myChart.setOption(option);
                    window.onresize = myChart.resize;
                }
            })
        },
        //可视化--上市公司行业分布情况
        echartsUpmarketWork(){
            let myChart = echarts.init(document.getElementById('upmarket_echarts_work'));
            let option = {
                tooltip: {},
                series: [{
                    type: 'treemap',
                    roam:'false', 
                    breadcrumb:{
                        show:false
                    },
                    data: [
                        // {
                        //     name: 'nodeA',            // First tree
                        //     value: 10,
                        //     children: [{
                        //         name: 'nodeAa',       // First leaf of first tree
                        //         value: 4
                        //     }, {
                        //         name: 'nodeAb',       // Second leaf of first tree
                        //         value: 6
                        //     }]
                        // }
                    ]
                }]
            };
            api.upmarketworkNum().then(res=>{
                let _data = res.data;
                option.series[0].data = _data;
                if (option && typeof option === "object") {
                    myChart.setOption(option);
                    window.onresize = myChart.resize;
                }
            })
        },
        //可视化--上海证券交易所+深圳证券交易所
        echartsUpmarketImgOne(){
            let _this = this;
            api.upmarketImgOne().then(res=>{
                let _data = res.data;
                _this.graph.count1 = _data;
            })

            api.upmarketImgTwo().then(res=>{
                let _data = res.data;
                _this.graph.count2 = _data;
            })
        }
    },
    created(){

    },
    mounted(){
        this.echartsAllCount();//上市公司总数
        this.echartsMap();//上市公司区域分布图
        this.echartsUpmarketNum();//上市公司数量
        this.echartsUpmarketTimeNum();//上市公司新增数量随时间分布情况
        this.echartsUpmarketWork();//上市公司行业分布情况
        this.echartsUpmarketImgOne();//上海证券交易所

        this.fetchTreeData();//股票搜索--树形图数据获取
        this.searchTextFetchSelectFn();//选择字段--下拉框数据获取
        this.searchAllBtn(1,1);//进入页面加载表格数据
        this.bodyCloseAlert();//点击空白关闭股票弹出框

    }
}
</script>
<style scoped lang="less">
@import "../../assets/less/tableScrollbar.less";

.home{
    width: 100%;
    height: 100%;
    background: #f4f4f4;
}
@media screen and (min-width: 1400px) {
    .showTablesDiv{
        min-height: calc(70vh - 275px);
    }
}
@media screen and (max-width: 1399px) {
    .showTablesDiv{
        min-height: calc(70vh - 150px);
    }
}
</style>


// WEBPACK FOOTER //
// src/view/upmarket/index.vue